import React from 'react'
import './styles.scss'
import { config } from './config'

export const MetaInfos = ({ authors, updated }: MetaInfosProps) => (
  <div className='ta metainfo'>
    <div className='ta author'>
      {authors.map((author, i) => {
        return (
          <>
            <span>{author}</span>
            {i < authors.length - 1 && <>, </>}
          </>
        )
      })}
    </div>
    {updated && <div className='ta updated'>Aktualisiert am {updated}</div>}
  </div>
)
